export default __webpack_public_path__ + "static/media/banner4.23673879.png";